import { FC, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { ThemeContext } from 'styled-components';
import { ProjectStage } from '../../../../enums';
import { EntityType } from '../../../../enums/EntityType';
import useForm from '../../../../hooks/form/UseForm';
import useProject from '../../../../hooks/project/UseProject';
import {
  StageBodyText,
  StageInner,
  StageWrapper,
} from '../../../../main/theme';
import { showModal } from '../../../../store/modal';
import { updateActiveProjectStage } from '../../../../store/project-stage';
import ActionBar from '../../../ActionBar/ActionBar';
import AdvancedSetting from '../../../AdvancedSetting/AdvancedSetting';
import FeatureButton, {
  FeatureButtonSize,
} from '../../../FeatureButton/FeatureButton';
import { ModalTypes } from '../../../Modal/Modal';

const ProjectItemFormConfigurationStage: FC = () => {
  const dispatch = useDispatch();
  const themeContext = useContext(ThemeContext);
  const { form } = useForm();
  const { activeConnection } = useProject();

  return (
    <StageWrapper>
      <StageInner>
        <StageBodyText>
          These settings should only be changed if you're absolutely positive on
          what they do.
        </StageBodyText>
        <StageBodyText>
          Some of these operations are <strong>irreversible</strong>.
        </StageBodyText>

        <AdvancedSetting
          action={() =>
            dispatch(
              showModal({
                visible: true,
                modal: ModalTypes.DELETION,
                additionalProps: {
                  entityType: EntityType.FORM,
                  entityId: form?._id,
                  entityName: form?.name,
                  connectionId: activeConnection?._id,
                },
              }),
            )
          }
          headerText={'Delete Form'}
          subHeaderText={`Delete your form completely.`}
          bodyText={`Be absolutely sure you wish to delete this form before
          proceeding.`}
          actionButtonText={'Delete Form'}
          actionButtonColor={themeContext.colors.general.red}
        />
      </StageInner>

      <ActionBar
        backButton={
          <FeatureButton
            action={() => {
              dispatch(updateActiveProjectStage(ProjectStage.CREATION));
            }}
            size={FeatureButtonSize.WIDE}
            color={themeContext.colors.general.sea}
            text={'Back to Overview'}
          />
        }
      />
    </StageWrapper>
  );
};

export default ProjectItemFormConfigurationStage;
